var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDepartmentRelatedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#departmentRelatedIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#21272A",
  d: "M7.596.482a.627.627 0 0 1 .81 0l6.875 5.833a.624.624 0 1 1-.807.953l-.64-.542v4.857a2.083 2.083 0 0 1-2.084 2.084h-7.5a2.083 2.083 0 0 1-2.084-2.084V6.726l-.638.542a.624.624 0 1 1-.807-.953L7.596.482ZM8 1.779 3.416 5.667v5.916c0 .461.373.834.834.834h7.5a.832.832 0 0 0 .833-.834V5.667L8 1.779Zm-.834 3.97c0-.228.188-.416.417-.416h.833c.23 0 .417.188.417.417V7h1.25c.23 0 .417.187.417.417v.833c0 .23-.188.417-.417.417h-1.25v1.25c0 .229-.187.416-.417.416h-.833a.418.418 0 0 1-.417-.416v-1.25h-1.25A.418.418 0 0 1 5.5 8.25v-.833c0-.23.187-.417.416-.417h1.25V5.75Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "departmentRelatedIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5.333h15v13.333H.5z"
})))));
export default SvgDepartmentRelatedIcon;